var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "50px", height: "80%" },
          attrs: {
            title: _vm.title,
            width: 800,
            ok: false,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            okButtonProps: { props: { disabled: _vm.disableSubmit } },
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form, id: "organizationModal" } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "名称",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["orgAbr", _vm.validatorRules.orgAbr],
                            expression: "['orgAbr', validatorRules.orgAbr ]",
                          },
                        ],
                        attrs: { placeholder: "请输入名称" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "编号",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["orgNo", _vm.validatorRules.orgNo],
                            expression: "['orgNo', validatorRules.orgNo ]",
                          },
                        ],
                        attrs: { placeholder: "请输入编号" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "上级部门",
                      },
                    },
                    [
                      _c("a-tree-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["parentId"],
                            expression: "[ 'parentId' ]",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          dropdownStyle: {
                            maxHeight: "200px",
                            overflow: "auto",
                          },
                          "allow-clear": "",
                          treeDefaultExpandAll: true,
                          treeData: _vm.departTree,
                          placeholder: "请选择上级部门",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "排序",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["sort"],
                            expression: "[ 'sort' ]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "备注",
                      },
                    },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["remark"],
                            expression: "[ 'remark' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入备注", rows: 2 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }